// extracted by mini-css-extract-plugin
export var root = "ArticleTile-root-2XgGt";
export var rootCard = "ArticleTile-root_card-Usgeo";
export var rootCardCategory = "ArticleTile-root_cardCategory-ZxUzh";
export var rootCardDate = "ArticleTile-root_cardDate-f+weK";
export var rootCardDescription = "ArticleTile-root_cardDescription-nT5V3";
export var rootCardDetails = "ArticleTile-root_cardDetails-dJl6P";
export var rootCardHeading = "ArticleTile-root_cardHeading--YqRc";
export var rootCardImage = "ArticleTile-root_cardImage-Cgz7g";
export var rootCardPicture = "ArticleTile-root_cardPicture-h8g++";
export var rootCardPicturePlaceholder = "ArticleTile-root_cardPicturePlaceholder-sodm1";
export var rootCardReadTime = "ArticleTile-root_cardReadTime-E4YBN";
export var rootCardReadTimeIcon = "ArticleTile-root_cardReadTimeIcon-qCFFq";
export var rootCardReadTimeWrapper = "ArticleTile-root_cardReadTimeWrapper-8YfDo";